import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-edit-all-passenger-comission',
  templateUrl: './edit-all-passenger-comission.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditAllPassengerComissionComponent {
  value: number = null;
  @Output() sendCommission = new EventEmitter<number>();
}
